import type { AccountingPolicy } from '@libs/domain';
import { settlementDateCriteria } from '@libs/enums';
import { getMaxDayPerMonth, getNextYm } from '@ps-smart-cp/ppfw-client';

type AccountingPolicySchema = Pick<AccountingPolicy['schema'], 'settlementDateBasis' | 'settlementDate'>;

function calcEndDateOfProcessingMonth(processingMonth: Date, accountingPolicy: AccountingPolicySchema): Date {
  const { settlementDateBasis, settlementDate } = accountingPolicy;

  switch (settlementDateBasis) {
    case settlementDateCriteria.enum.eom: {
      const days = getMaxDayPerMonth(processingMonth.getFullYear());
      const date = new Date(processingMonth.getTime());
      date.setDate(days[processingMonth.getMonth()]);
      return date;
    }
    case settlementDateCriteria.enum.one: {
      const nextYm = getNextYm(processingMonth);
      const [yearStr, monthStr] = nextYm!.split('/');
      const year = Number(yearStr);
      const month = Number(monthStr) - 1;
      const maxDay = getMaxDayPerMonth(year)[month];
      const day = Math.min(Number(settlementDate), maxDay);
      return new Date(year, month, day);
    }
    case settlementDateCriteria.enum.two: {
      const year = processingMonth.getFullYear();
      const month = processingMonth.getMonth();
      const maxDay = getMaxDayPerMonth(year)[month];
      const day = Math.min(Number(settlementDate), maxDay);
      const date = new Date(processingMonth.getTime());
      date.setDate(day);
      return date;
    }
    default:
      throw new Error('Invalid settlementDateCriteria value');
  }
}

export { calcEndDateOfProcessingMonth };
